import Serie_BKT from "../assets/images/Serie_BKT.svg";
import BNLTENNIS from "../assets/images/BNLTENNIS.png";
import Serie_A_Women from "../assets/images/Serie_A_Women.webp";
import WomenVolley_A from "../assets/images/WomenVolley_A.png";
import WomenVolley_Auth_A from "../assets/images/WomenVolley_Auth_A.png";
import SerieA from "../assets/images/Serie_A.svg";
import Sky from "../assets/images/Sky_Group_logo_2020.webp";
import FIGC from "../assets/images/Logo_Federazione_Italiana_Giuoco_Calcio_-_2021.webp";
import { Box } from "@mui/material";
import {CURRENT_SPORT, SUPPORTED_CONTENTS} from "@/constants/globalConstants";
import { OverlayType } from "reactvideoeditor/pro/types";
import {useContentSpecificParams} from "@/contexts/ContentSpecificParamsContext";
import soccerPlayerIcon from '../assets/images/icons/soccer-player.png';
import tennisPlayerIcon from '../assets/images/icons/tennis-player.png'
import volleyPlayerIcon from '../assets/images/icons/volley-player.png';
import fallbackThumbnailSerieB from "../assets/images/highlight_thumbnail_serie_b.png";
import fallbackThumbnailserieaWomenCup from "../assets/images/highlight_thumbnail_serie_a_women.jpg";
import fallbackThumbnailSerieA from "../assets/images/highlight_thumbnail_serie_a.png";
import fallbackThumbnailVolleySerieA from "../assets/images/highlight_thumbnail_serie_a_womenVolley.png";
import { SUPPORTED_SPORTS } from "../constants/globalConstants";

// Pagine di auth: il loro segmento (es. /login) non è una subroot
const AUTH_PAGES = ['login', 'register', 'forgot-password', 'check-mail', 'reset-password', 'code-verification'];

export const thumbnailMap = {
  "/legaSerieb": fallbackThumbnailSerieB,
  "/seriea": fallbackThumbnailSerieA,
  "/serieaWomenCup": fallbackThumbnailserieaWomenCup,
  "/tennis": BNLTENNIS,
  "/volleya": fallbackThumbnailVolleySerieA,
};

export const logoMap = {
  "legaSerieb": Serie_BKT,
  //"seriea": Sky,
  "serieaWomenCup": Serie_A_Women,
  "seriea": SerieA,
  "tennis": BNLTENNIS,
  "volleya": WomenVolley_A,
};

export const logoAuthLeftMap = {
  "legaSerieb": Serie_BKT,
  //"seriea": Sky,
  "figc": FIGC,
  "serieaWomenCup": Serie_A_Women,
  "seriea": SerieA,
  "tennis": BNLTENNIS,
  "volleya": WomenVolley_Auth_A,
};

// Logo of the login page shown on the right side of the screen, mirroring the one of logoAuthLeftMap
// on the left (a subroot without one shows no logo there)
export const logoAuthRightMap = {
  "legaSerieb": Serie_BKT,
  //"seriea": Sky,
  "serieaWomenCup": Serie_A_Women,
  "seriea": SerieA,
  "tennis": BNLTENNIS,
  "volleya": WomenVolley_Auth_A,
};

export const sportIconMap = {
  "legaSerieb": {icon: soccerPlayerIcon, sport: 'FOOTBALL'},
  "seriea": {icon: soccerPlayerIcon, sport: 'FOOTBALL'},
  "figc": {icon: soccerPlayerIcon, sport: 'FOOTBALL'},
  "serieaWomenCup": {icon: soccerPlayerIcon, sport: 'FOOTBALL'},
  "tennis": {icon: tennisPlayerIcon, sport: 'TENNIS'},
  "volleya": {icon: volleyPlayerIcon, sport: 'VOLLEY'},
};
  
export const global_page_collection_size = 7;

export const mappingRoute={
  'keymoments': 'key_moments',
  'clips': 'clips'
}

export function getSubRoot(pathname) {
  if (!pathname) return '';
  const parts = pathname.split('/').filter(Boolean);
  return parts.length > 0 && !AUTH_PAGES.includes(parts[0]) ? `/${parts[0]}` : '';
}

// Nome della subroot corrente senza slash: è l'organizzazione, e la chiave
// di logoMap / logoAuthLeftMap / sportIconMap; '' senza subroot
export const getSubRootName = (pathname = window.location.pathname) => getSubRoot(pathname).slice(1);

// Subroot of the last successful login, kept in localStorage until logout /
// session expiry: target of the logout redirect and of the "Back To Home" buttons of the error pages
export const LOGIN_SUBROOT_KEY = 'loginSubroot';

// null / undefined, also as stored by localStorage (which stringifies them) or as a subroot
// built from them (e.g. `/${organization}` with no organization)
const INVALID_SUBROOTS = ['null', 'undefined', '/null', '/undefined'];
const isValidSubroot = (subroot) =>
  subroot !== null && subroot !== undefined && !INVALID_SUBROOTS.includes(String(subroot));

// Login subroot from localStorage, null when missing or not valid
export const getLoginSubroot = () => {
  const subroot = localStorage.getItem(LOGIN_SUBROOT_KEY);
  return isValidSubroot(subroot) ? subroot : null;
};

// Saves the login subroot, ignoring values that are not valid
export const setLoginSubroot = (subroot) => {
  if (isValidSubroot(subroot)) localStorage.setItem(LOGIN_SUBROOT_KEY, subroot);
};

// Full URL of <path> under the login subroot ('' when there's none): meant for a full page load,
// since routes are derived from window.location and the current page may be under another subroot
export const getLoginSubrootUrl = (path) => {
  const subroot = getLoginSubroot();
  if (!subroot) return '';
  const basename = (import.meta.env.VITE_APP_BASE_NAME || '/').replace(/\/+$/, '');
  return `${basename}${subroot}${path}`;
};

export function getUrl(pathname, target) {
  const subRoot = getSubRoot(pathname);

  // Evita duplicazione se target include già la sub-root
  if (target.startsWith(subRoot + '/')) {
    return target;
  }

  // Evita doppio slash
  if (target.startsWith('/')) {
    return subRoot + target;
  }

  return `${subRoot}/${target}`;
}

// Funzione guardia: è ammessa solo una subroot con un logo in logoMap, le altre vanno in 404.
// Al login il backend verifica poi che l'utente veda l'organizzazione corrispondente
// The mapped names (the ones of the URL, e.g. 'legaserieb') of the organizations the backend
// returns as [{ mapped_name, original_name }]
// null when the backend sent no organization list at all: the session is then refused (JWTContext)
export const getMappedOrganizations = (organizations) =>
  Array.isArray(organizations) ? organizations.map((organization) => organization?.mapped_name).filter(Boolean) : null;

// Whether the user may open the organization of the URL. Based only on what the backend returned
// (user.visibleOrganizations), never on localStorage, which the user can edit. False without the list
export const canAccessSubroot = (user, pathname = window.location.pathname) => {
  const visible = user?.visibleOrganizations;
  if (!Array.isArray(visible)) return false;
  const name = getSubRootName(pathname).toLowerCase();
  return visible.some((organization) => organization.toLowerCase() === name);
};

export const stripValidRoot = (pathname) => {
  if (!pathname) return null;
  const clean = pathname.replace(/\/+$/, "");
  const root = getSubRoot(clean);
  return root ? (clean.slice(root.length) || "/") : null;
};

export function formatSafeUTCDate(dateString, includeSeconds = true, includeTime = true) {
  if (!dateString) return '';

  let safeDateString = dateString;
  if (!safeDateString.includes('Z') && !safeDateString.includes('+')) {
    safeDateString += 'Z';
  }

  const date = new Date(safeDateString);
  if (isNaN(date.getTime())) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  let ris = `${day}-${month}-${year}`;
  if (includeTime) ris += ` ${hours}:${minutes}`;
  if (includeSeconds) ris += `:${seconds}`;

  return ris;
}

export function formatUTCDate(dateString, includeSeconds = true, includeTime = true) {
  if (dateString && !dateString.includes('Z')){
    dateString += 'Z';
  }
  const date = new Date(dateString);
  if (isNaN(date.getTime())){
    return '';
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  let ris = `${day}-${month}-${year}`;
  if (includeTime) {
    ris += ` ${hours}:${minutes}`;
  }
  if (includeSeconds) {
    ris += ':'+seconds;
  }
  return ris;
}

export const customOptionsCreateButtons = [
  {id: "clip", label: "Create Clip"},
    {id: "highlights", label: "Create Highlight"},
]

export const formatDuration = (totalSeconds) => {
  if (!totalSeconds || totalSeconds <= 0) return "0s";

  const SECONDS_IN_MONTH = 2592000; // 30 * 86400
  const SECONDS_IN_WEEK = 604800;   // 7 * 86400
  const SECONDS_IN_DAY = 86400;
  const SECONDS_IN_HOUR = 3600;
  const SECONDS_IN_MINUTE = 60;

  const months = Math.floor(totalSeconds / SECONDS_IN_MONTH);
  const weeks = Math.floor((totalSeconds % SECONDS_IN_MONTH) / SECONDS_IN_WEEK);
  const days = Math.floor((totalSeconds % SECONDS_IN_WEEK) / SECONDS_IN_DAY);
  const hours = Math.floor((totalSeconds % SECONDS_IN_DAY) / SECONDS_IN_HOUR);
  const minutes = Math.floor((totalSeconds % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE);

  const parts = [];

  if (months > 0) {
    if (months === 1)
      parts.push(`${months} month`);
    else
      parts.push(`${months} months`);
  }
  if (weeks > 0) {
    if(weeks === 1)
      parts.push(`${weeks} week`);
    else
      parts.push(`${weeks} weeks`);
  }
  if (days > 0) {
    if (days === 1)
      parts.push(`${days} day`);
    else
      parts.push(`${days} days`);
  }
  if (hours > 0) {
    if (hours === 1)
      parts.push(`${hours} hour`);
    else
      parts.push(`${hours} hours`);
  }
  if (minutes > 0) {
    if (minutes === 1)
      parts.push(`${minutes} minute`);
    else
      parts.push(`${minutes} minutes`);
  }

  return parts.join(' ');
};

export function secondsToGameTime(totalSeconds) {
  if (typeof totalSeconds !== "number" || totalSeconds < 0) return "00:00";

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.floor(totalSeconds % 60);

  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = seconds.toString().padStart(2, "0");

  return `${formattedMinutes}:${formattedSeconds}`;
}

export default function downloadVideo(videoUrl, fileName) {
  const link = document.createElement('a');
  link.href = videoUrl;

  link.setAttribute('download', fileName || 'video.mp4');

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function formatTime(secondsInput) {
  const totalSeconds = Math.max(0, Math.floor(secondsInput));

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const pad = (n) => n.toString().padStart(2, "0");

  if (hours > 0) {
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  } else {
    return `${pad(minutes)}:${pad(seconds)}`;
  }
}

// Array is the list of Time, while target is our single time
export function findClosestEvent(events, target) {

  if (!events || events.length === 0 || !target) {
    return null;
  }

  const targetTime = new Date(target).getTime();

  let low = 0;
  let high = events.length - 1;

  let closestEvent = events[0];

  while (low <= high) {
    let mid = Math.floor((low + high) / 2);
    let midTime = new Date(events[mid].start_schedule).getTime();
    let currentClosestTime = new Date(closestEvent.start_schedule).getTime();

    // Controlliamo se l'elemento corrente (mid) è più vicino al target rispetto al closestEvent trovato finora
    if (Math.abs(midTime - targetTime) < Math.abs(currentClosestTime - targetTime)) {
      closestEvent = events[mid];
    }

    // Logica della ricerca binaria (richiede array ordinato ASC)
    if (midTime === targetTime) {
      return events[mid];
    } else if (midTime < targetTime) {
      low = mid + 1;
    } else {
      high = mid - 1;
    }
  }

  return closestEvent;
}

export const SlashedIcon = ({ children, active, flip = false }) => (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      {children}
      {!active && (
          <Box
              sx={{
                position: 'absolute',
                width: '130%',
                height: '1.5px',
                bgcolor: 'currentColor',
                top: '50%',
                left: '-15%',
                transform: `rotate(${flip ? 45 : -45}deg)`,
              }}
          />
      )}
    </Box>
);

export const getContentRenderParams = (contentType, contentSpecificParams) => {  
  switch (contentType){
      case SUPPORTED_CONTENTS[CURRENT_SPORT].MATCH_HIGHLIGHT: return {event_ids: [contentSpecificParams?.match?.id]}
      default: return {}
  }
}

export const getDeterministicColor = (nome, cognome) => {
  // 1. Palette di 22 colori accuratamente selezionati per Dark Mode + Testo Bianco
  const COLOR_PALETTE = [
    '#DC2626', // Rosso vibrante
    '#B91C1C', // Rosso scuro
    '#EA580C', // Arancione scuro
    '#D97706', // Ambra / Oro carico
    '#16A34A', // Verde foresta vivo
    '#15803D', // Verde scuro
    '#059669', // Smeraldo
    '#0D9488', // Ottanio (Teal)
    '#0F766E', // Ottanio scuro
    '#0891B2', // Ciano profondo
    '#0284C7', // Sky Blue
    '#0369A1', // Deep Sky
    '#2563EB', // Blu Reale
    '#1D4ED8', // Blu scuro
    '#4F46E5', // Indaco
    '#7C3AED', // Violetto
    '#6D28D9', // Viola profondo
    '#9333EA', // Porpora
    '#C026D3', // Fucsia
    '#DB2777', // Rosa scuro
    '#E11D48', // Rose / Smeraldo
    '#BE123C'  // Cardinale
  ];

  // 2. Normalizzazione per evitare differenze tra maiuscole/minuscole e spazi
  const str = `${(nome || "").trim()} ${(cognome || "").trim()}`.toLowerCase();

  // 3. Generazione dell'hash deterministico (mantenendo la tua logica)
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  // 4. Mappatura dell'hash sulla lunghezza della palette.
  // Usiamo Math.abs perché l'operazione di bitwise in JS può generare numeri negativi.
  const index = Math.abs(hash) % COLOR_PALETTE.length;

  return COLOR_PALETTE[index];
};